import { render, staticRenderFns } from "./SlaService.vue?vue&type=template&id=10215a36&scoped=true&"
import script from "./SlaService.vue?vue&type=script&lang=js&"
export * from "./SlaService.vue?vue&type=script&lang=js&"
import style0 from "./SlaService.vue?vue&type=style&index=0&id=10215a36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10215a36",
  null
  
)

export default component.exports